var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftNav"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index},[(
        _vm.type == '医案病历' ||
        item.name == '专题学习' ||
        item.name == '经验挖掘' ||
        item.name == '专题图谱'
      )?_c('div',{class:{ active: _vm.href.indexOf(item.activePath) !== -1 },on:{"click":function($event){return _vm.goRoute(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }